import React from "react";
import { StyleSheet, View } from "react-native";
import Skeleton from "../../../chat-companion/Skeleton/Skeleton";
import { spacing } from "../../../../styles/design-system";

/**
 * Subtle skeleton-style streaming indicator shown below the AI message text
 * while it's actively streaming. Uses short shimmer bars to convey "more
 * content is loading" without disrupting the reading flow.
 */
const StreamingCursor: React.FC = () => (
  <View style={styles.container}>
    <Skeleton width="45%" height={10} borderRadius={4} variant="colorful" />
  </View>
);

const styles = StyleSheet.create({
  container: {
    marginTop: spacing.xs,
    marginBottom: spacing.xs,
  },
});

export default React.memo(StreamingCursor);
